//1.Import

import Layout from '../Layout';
import PageHeader from "../sections/PageHeader";
import Swiper from 'swiper/bundle';
import "@lottiefiles/lottie-player";

//2.Initialization
const layout=new Layout();
const pageHeader=new PageHeader();

//3.Events
window.addEventListener('DOMContentLoaded', function() {
    pageHeader.init();
    scene();
});

//4. Functions
function scene(){
    let orderMadeSwiper = new Swiper(".card-sceneBig__swiper", {
        slidesPerView: 1,
        spaceBetween: 12,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 64,
                autoHeight:false,
            },
        },
    });
}
